import React, { useState, useEffect } from "react";
import { Button, TextField } from "@mui/material";
import { useParams } from "react-router-dom";
import { useRef } from "react";
import * as sweetalert from "sweetalert";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Grid } from "@material-ui/core";
import packageJson from "../../../../package.json";
import Controls from "../global/controls/Controls";
import ImageInput from "../../../components/images/image";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export default function Profile() {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, cityid, zoneid } = useParams();
  const [staff, setStaff] = useState([]);
  const [Staffoption, setStaffoption] = useState([]);
  const [city, setCity] = useState([]);
  const [Countries, setCountries] = useState([]);
  const [city_id, setcity_id] = useState("1");
  const [admin, setAdmin] = useState("");
  const [adminArabic, setAdminArabic] = useState("");
  const [zone, setZone] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");
  const [selectedImage2, setSelectedImage2] = useState("");
  const [selectedImage3, setSelectedImage3] = useState("");
  const [img, setImg] = useState("");
  const [img1, setImg1] = useState("");
  const [img2, setImg2] = useState("");
  const staff_type = localStorage.getItem("staff_type");

  const imageChange = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      // Assuming you only care about the first file in case of multiple files
      const file = e.target.files[0];
      if (file) {
        // Check if file size is less than 512 KB
        if (file.size <= 512 * 1024) {
          // 512 KB
          // If file size is valid, update state to reflect the new image
          setSelectedImage(file);
          // Clear any error related to file size if there was one
          setFormValues((prevState) => ({
            ...prevState,
            personal_photo: {
              value: file,
              error: "",
            },
          }));
        } else {
          // If file size is not valid, set an error and do not update the image
          setFormValues((prevState) => ({
            ...prevState,
            personal_photo: {
              ...prevState.personal_photo,
              error: "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت",
            },
          }));
        }
      }
      setSelectedImage(e.target.files[0]);
    }
  };
  const imageChange2 = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file) {
        // Check if file size is less than 512 KB
        if (file.size <= 512 * 1024) {
          // 512 KB
          // If file size is valid, update state to reflect the new image
          setSelectedImage2(file);
          // Clear any error related to file size if there was one
          setFormValues((prevState) => ({
            ...prevState,
            id_photo1: {
              value: file,
              error: "",
            },
          }));
        } else {
          // If file size is not valid, set an error and do not update the image
          setFormValues((prevState) => ({
            ...prevState,
            id_photo1: {
              ...prevState.id_photo1,
              error: "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت",
            },
          }));
        }
      }
      setSelectedImage2(e.target.files[0]);
    }
  };
  const imageChange3 = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      if (file) {
        // Check if file size is less than 512 KB
        if (file.size <= 512 * 1024) {
          // 512 KB
          // If file size is valid, update state to reflect the new image
          setSelectedImage3(file);
          // Clear any error related to file size if there was one
          setFormValues((prevState) => ({
            ...prevState,
            id_photo2: {
              value: file,
              error: "",
            },
          }));
        } else {
          // If file size is not valid, set an error and do not update the image
          setFormValues((prevState) => ({
            ...prevState,
            id_photo2: {
              ...prevState.id_photo2,
              error: "حجم الصورة يجب أن يكون أقل من 512 كيلوبايت",
            },
          }));
        }
      }
      setSelectedImage3(e.target.files[0]);
    }
  };
  const [city_id2, setcity_id2] = useState({
    city_id: {
      value: "",
    },
  });
  const [PersonImage, setPersonImage] = useState([]);
  const [Photo1, setPhoto1] = useState([]);
  const [Photo2, setPhoto2] = useState([]);
  const [selectedImages, setSelectedImages] = useState({
    personalImage: [],
    frontIdImage: [],
    backIdImage: [],
  });
  const imageRef = useRef();
  const [formValues, setFormValues] = useState({
    first_name: {
      value: "",
      error: "",
    },
    last_name: {
      value: "",
      error: "",
    },
    father_name: {
      value: "",
      error: "",
    },
    mother_name: {
      value: "",
      error: "",
    },
    mobile_number: {
      value: "",
      error: "",
    },
    id_number: {
      value: "",
      error: "",
    },
    address: {
      value: "",
      error: "",
    },
    staff_type: {
      value: "",
      error: "",
    },
    city_id: {
      value: "",
      error: "",
    },
    zone_id: {
      value: "",
      error: "",
    },
    active: {
      value: 1,
      error: "",
    },
    personal_photo: {
      value: "",
      error: "",
    },
    id_photo1: {
      value: "",
      error: "",
    },
    id_photo2: {
      value: "",
      error: "",
    },
  });
  const validate = () => {
    let isValid = true;
    let temp = { ...formValues };

    // Example validation, customize according to your needs
    if (!temp.first_name.value) {
      temp.first_name.error = "الحقل مطلوب";
      isValid = false;
    } else {
      temp.first_name.error = "";
    }

    if (!temp.last_name.value) {
      temp.last_name.error = "الحقل مطلوب";
      isValid = false;
    } else {
      temp.last_name.error = "";
    }
    if (!temp.father_name.value) {
      temp.father_name.error = "الحقل مطلوب";
      isValid = false;
    } else {
      temp.father_name.error = "";
    }
    if (!temp.mother_name.value) {
      temp.mother_name.error = "الحقل مطلوب";
      isValid = false;
    } else {
      temp.mother_name.error = "";
    }

    if (!temp.mobile_number.value) {
      temp.mobile_number.error = "الحقل مطلوب";
      isValid = false;
    } else {
      temp.mobile_number.error = "";
    }

    if (!temp.id_number.value) {
      temp.id_number.error = "الحقل مطلوب";
      isValid = false;
    } else if (temp.id_number.value.length !== 11) {
      temp.id_number.error = "يجب أن يكون رقم الوطني 11 رقمًا";
      isValid = false;
    } else {
      temp.id_number.error = "";
    }
    if (temp.personal_photo.error !== "") {
      isValid = false;
    }
    if (temp.id_photo1.error && temp.id_photo1.error !== "") {
      isValid = false;
    }
    if (temp.id_photo2.error && temp.id_photo2.error !== "") {
      isValid = false;
    }

    // Add more validation checks for other fields

    setFormValues({
      ...temp,
    });

    return isValid;
  };

  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/profile`, {
        withCredentials: true,
      })
      .then((res) => {
        // setSelectedImages({
        //   ...selectedImages,
        //   personalImage: res.data.data.images.personal_photo,
        //   frontIdImage: res.data.images.id_photo1,
        //   backIdImage: res.data.images.id_photo2,
        // })

        setAdmin(res.data.data.staff_type);
        if (res.data.data.staff_type == "ادمن") {
          setAdminArabic("ادمن");
        }
        if (res.data.data.staff_type == "موزع عام") {
          setAdminArabic("موزع عام");
        }
        if (res.data.data.staff_type == "موزع خاص") {
          setAdminArabic("موزع خاص");
        }
        if (res.data.data.staff_type == "زبون") {
          setAdminArabic("زبون");
        }

        setFormValues({
          first_name: {
            value: res.data.data.first_name,
          },
          last_name: {
            value: res.data.data.last_name,
          },
          father_name: {
            value: res.data.data.father_name,
          },
          mother_name: {
            value: res.data.data.mother_name,
          },
          mobile_number: {
            value: res.data.data.mobile_number,
          },
          id_number: {
            value: res.data.data.id_number,
          },
          address: {
            value: res.data.data.address,
          },
          staff_type: {
            value: res.data.data.staff_type,
          },
          city_id: {
            value: res.data.data.city_id,
          },
          zone_id: {
            value: res.data.data.zone_id,
          },
          personal_photo: {
            value: res.data.data.images.personal_photo,
            error: "",
          },
          id_photo1: {
            value: res.data.data.images.id_photo1,
            error: "",
          },
          id_photo2: {
            value: res.data.data.images.id_photo2,
            error: "",
          },
          active: {
            value: 1,
          },
        });
        setImg([res.data.data.images.personal_photo]);
        setImg1([res.data.data.images.id_photo1]);
        setImg2([res.data.data.images.id_photo2]);
      })
      .catch((err) => {});
  }, []);
  useEffect(() => {
  }, [formValues]);
  useEffect(() => {
    setTimeout(() => {
      if (formValues.zone_id.value) {
        setIsLoading(true);
      }
    }, 1000);
  }, [formValues.zone_id.value]);
  useEffect(() => {
    const config = {
      headers: { "Content-Type": "application/json", Authorization: null },
    };
    axios.get(`${BaseUrl}/sanctum/csrf-cookie`, config).then((response) => {
      axios
        .get(`${BaseUrl}/api/countries`, {
          withCredentials: true,
        })
        .then((res) => {
          setCountries(res.data.data);

          setcity_id(res.data.data[0].id);
          axios
            .get(`${BaseUrl}/api/country/${city_id}/cities`, {
              withCredentials: true,
            })
            .then((rescities) => {
              setCity(rescities.data.data);
            });
        });
    });
  }, []);
  useEffect(() => {
    axios
      .get(`${BaseUrl}/api/GetStaffType`, {
        withCredentials: true,
      })
      .then((res) => {
        setStaff(res.data.data);
      });
  }, []);
  useEffect(() => {
    const zoneId = formValues.zone_id.value;
    const cityId = formValues.city_id.value;

    if (zoneId && cityId) {
      const config = {
        headers: { "Content-Type": "application/json", Authorization: null },
      };

      axios.get(`${BaseUrl}/sanctum/csrf-cookie`, config).then(() => {
        axios
          .get(`${BaseUrl}/api/countries`, { withCredentials: true })
          .then((res) => {
            setCountries(res.data.data);
            const Id = res.data.data[0]?.id; // Ensure ID exists
            if (Id) {
              setTimeout(() => {
                axios
                  .get(`${BaseUrl}/api/country/${Id}/city/${cityId}/zones`, {
                    withCredentials: true,
                  })
                  .then((resZone) => {
                    setZone(resZone.data.data);
                  });
              }, 1000);
            }
          });
      });
    }
  }, [formValues.zone_id.value, formValues.city_id.value]);
  // useEffect(() => {
  //   if(formValues.zone_id.value ){
  //   const config = {
  //     headers: { "Content-Type": "application/json", Authorization: null },
  //   };
  //   axios
  //     .get(
  //       `${BaseUrl}/sanctum/csrf-cookie`,
  //       config
  //     )
  //     .then((response) => {
  //       axios
  //         .get(
  //           `${BaseUrl}/api/countries`,
  //           {
  //             withCredentials: true,
  //           }
  //         )
  //         .then((res) => {
  //           setCountries(res.data.data);
  //           const Id = res.data.data[0].id;
  //           setTimeout(() => {
  //             axios
  //               .get(
  //                 `${BaseUrl}/api/country/${Id}/city/${formValues.city_id.value}/zones`,
  //                 { withCredentials: true }
  //               )
  //               .then((resZone) => {
  //                 setZone(resZone.data.data);
  //               });
  //           }, 1000);
  //         });
  //     });
  //   }
  // });
  const handelcity = (e) => {
    e.persist();
    setcity_id2({ ...city_id2, [e.target.name]: e.target.value });
    setFormValues({
      ...formValues,
      [e.target.name]: {
        value: e.target.value,
        error: "",
      },
    });
  };

  const handleSubmit1 = (e) => {
    e.preventDefault();

    axios
      .get(`${BaseUrl}/api/country/${city_id}/city/${city_id2.city_id}/zones`, {
        withCredentials: true,
      })
      .then((resZone) => {
        setZone(resZone.data.data);
      });
  };

  function cancleUpdate() {
    {
      location.pathname == `/update-staff/${id}/${cityid}/${zoneid}`
        ? navigate("/")
        : navigate("/");
    }
  }
  const handleChange = (event) => {
    event.persist();
    // setFormValues({ ...formValues, [event.target.name]: event.target.value });
    setFormValues({
      ...formValues,
      [event.target.name]: {
        value: event.target.value,
        error: "",
      },
    });
  };
  const handleChangestaff = (event) => {
    event.persist();
    setFormValues({
      ...formValues,
      staff_type: {
        value: event.target.value,
        error: "",
      },
    });
    // setFormValues({ ...formValues, staff_type: { value: event.target.value } });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (validate()) {
      setLoading(true);
      const config = {
        headers: {
          Accept: "application/json",
          Authorization: null,
          sameSite: "strict",
        },
      };

      var fieldType;
      if (event.target.staff_type.value == admin) {
        setAdminArabic(adminArabic);
        fieldType = adminArabic;
        setFormValues({ ...formValues, staff_type: adminArabic });
      } else {
        setAdminArabic(event.target.staff_type.value);
        fieldType = Staffoption;
        setFormValues({ ...formValues, staff_type: Staffoption });
      }

      const formData = new FormData();
      formData.append("personal_photo", selectedImage);
      formData.append("id_photo1", selectedImage2);
      formData.append("id_photo2", selectedImage3);
      formData.append("first_name", formValues.first_name.value);
      formData.append("last_name", formValues.last_name.value);
      formData.append("father_name", formValues.father_name.value);
      formData.append("address", formValues.address.value);
      formData.append("mother_name", formValues.mother_name.value);
      formData.append("id_number", formValues.id_number.value);
      formData.append("staff_type", formValues.staff_type.value);
      formData.append("city_id", formValues.city_id.value);
      formData.append("zone_id", formValues.zone_id.value);
      formData.append("active", 1);
      axios
        .post(`${BaseUrl}/api/updateProfile`, formData, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.status === true) {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            }).then(() => {
              navigate("/");
            });
          } else {
            setLoading(false);
            sweetalert(res.data.msg, {
              className: "alert-div",
              button: {
                text: "تم",
              },
            });
          }
        });
    }
  };

  return (
    <div className="main-div-expanded-profile">
      <h3 className="titlepage">تعديل الحساب الشخصي</h3>
      <form
        method="post"
        enctype="multipart/form-data"
        noValidate
        onSubmit={handleSubmit}
      >
        {isLoading ? (
          <>
            <Grid container maxWidth="sm" spacing={4}>
              <Grid item md={6} xs={12}>
                <TextField
                  placeholder="الرجاء ادخال الاسم الأول"
                  className="form-control"
                  label="اسم المستخدم"
                  name="first_name"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.first_name.value}
                  error={!!formValues.first_name.error}
                  helperText={formValues.first_name.error}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  placeholder="الرجاء ادخالا الاسم الاخير"
                  className="form-control"
                  label="الكنية"
                  name="last_name"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.last_name.value}
                  error={!!formValues.last_name.error}
                  helperText={formValues.last_name.error}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <TextField
                  placeholder="الرجاء ادخال اسم الأب"
                  className="form-control"
                  label="اسم الأب"
                  name="father_name"
                  variant="outlined"
                  fullWidth
                  value={formValues.father_name.value}
                  error={!!formValues.father_name.error}
                  helperText={formValues.father_name.error}
                  onChange={handleChange}
                  type="text"
                />
              </Grid>
              <Grid item md={6} xs={12}>
                {" "}
                <TextField
                  placeholder="الرجاء ادخال اسم الأم"
                  className="form-control"
                  label="اسم الأم"
                  name="mother_name"
                  variant="outlined"
                  fullWidth
                  value={formValues.mother_name.value}
                  error={!!formValues.mother_name.error}
                  helperText={formValues.mother_name.error}
                  onChange={handleChange}
                  type="text"
                />
              </Grid>
              <Grid item md={6} xs={12}>
                <div class="select" disabled="true">
                  {" "}
                  <select
                    selected
                    name="staff_type"
                    class="select-text"
                    value={formValues.staff_type.value}
                    error={!!formValues.staff_type.error}
                    helperText={formValues.staff_type.error}
                    onChange={handleChangestaff}
                    disabled={true} // Add this line to disable the select element
                  >
                    <option selected disabled>
                      {adminArabic}
                    </option>
                    {staff.map((opts, i) => (
                      <option key={opts.id} value={opts.en_name}>
                        {opts.ar_name}
                      </option>
                    ))}
                  </select>
                  <span class="select-highlight"></span>
                  <span class="select-bar"></span>
                  <label class="select-label"> النوع </label>
                </div>
              </Grid>

              <Grid item md={6} xs={12}>
                {" "}
                <TextField
                  placeholder="الرجاء ادخال الرقم الوطني"
                  className="form-control"
                  label="الرقم الوطني"
                  name="id_number"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.id_number.value}
                  error={!!formValues.id_number.error}
                  helperText={formValues.id_number.error}
                  onChange={handleChange}
                />
              </Grid>
              <Grid item md={6} xs={12}>
                {" "}
                <TextField
                  placeholder="الرجاء إدخال العنوان التفصيلي"
                  className="form-control"
                  label="العنوان التفصيلي"
                  name="address"
                  variant="outlined"
                  fullWidth
                  type="text"
                  value={formValues.address.value}
                  error={!!formValues.address.error}
                  helperText={formValues.address.error}
                  onChange={handleChange}
                />
              </Grid>

              <Grid item md={6} xs={12}>
                <div class="select">
                  {" "}
                  <select
                    onChange={handleChange}
                    name="city_id"
                    class="select-text"
                    value={formValues.city_id.value}
                  >
                    {city.map((opts, i) => {
                      return (
                        <option key={i} onClick={handleSubmit1} value={opts.id}>
                          {opts.name_ar}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
              <Grid item md={6} xs={12}>
                <div class="select">
                  <select
                    selected
                    name="zone_id"
                    class="select-text"
                    onChange={handleChange}
                    value={formValues.zone_id.value}
                  >
                    {zone.map((opts, i) => {
                      return (
                        <option key={i} value={opts.id}>
                          {opts.name}
                        </option>
                      );
                    })}
                  </select>
                </div>
              </Grid>
              {/* <Grid item lg={12} md={12} xs={12}>
                <hr className="div-line-image"></hr>
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label style={{ textAlign: "center", marginBottom: "10px" }}>
                  صورة الشخصية
                </label>
                <ImageInput
                  // onChange={onChange}
                  onChange={(value) =>
                    setSelectedImages({
                      ...selectedImages,
                      personalImage: value,
                    })
                  }
                  value={selectedImages.personalImage} // Pass initial image data here
                  ref={imageRef}
                  title="صورة الشخصية"
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label style={{ textAlign: "center", marginBottom: "10px" }}>
                  صورة الهوية الأمامية
                </label>
                <ImageInput
                  onChange={(value) =>
                    setSelectedImages({
                      ...selectedImages,
                      frontIdImage: value,
                    })
                  }
                  ref={imageRef}
                  value={selectedImages.frontIdImage} // Pass initial image data here
                  title="صورة الهوية الأمامية"
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label style={{ textAlign: "center", marginBottom: "10px" }}>
                  صورة الهوية الخلفية
                </label>
                <ImageInput
                  onChange={(value) =>
                    setSelectedImages({ ...selectedImages, backIdImage: value })
                  }
                  ref={imageRef}
                  title="صورة الهوية الخلفية"
                  value={selectedImages.backIdImage} // Pass initial image data here

                />
              </Grid> */}
              <Grid
                item
                md={12}
                xs={12}
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  gap: "10px",
                }}
              >
                <Grid md={4} xs={4}>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      marginBottom: selectedImage !== "" ? "20px" : "0",
                    }}
                  >
                    {selectedImage ? (
                      <div
                        className="box_img_update"
                        style={{ marginTop: "-20px" }}
                      >
                                    
                        <img
                          src={URL.createObjectURL(selectedImage)}
                          alt="Thumb"
                        />
                      </div>
                    ) : (
                      <div className="box_img_update">
                        <img src={img} />
                      </div>
                    )}
                    {formValues.personal_photo.error && (
                      <div
                        style={{
                          color: "red",
                          marginTop: "30px",
                          height: "1px",
                        }}
                      >
                        {formValues.personal_photo.error}
                      </div>
                    )}
                         
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{
                      marginTop:
                        selectedImage !== "" &&
                        formValues.personal_photo.error == ""
                          ? "65px"
                          : selectedImage !== "" &&
                            formValues.personal_photo.error !== ""
                          ? "35px"
                          : "45px",
                    }}
                  >
                    <TextField
                      placeholder="الرجاءإدخال  لوغو نقطة البيع"
                      className="form-control"
                      label="لوغو نقطة البيع"
                      name="personal_photo"
                      fullWidth
                      required
                      type="file"
                      onChange={imageChange}
                    />
                  </Grid>
                </Grid>
                <Grid md={4} xs={4}>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      marginBottom: selectedImage2 !== "" ? "20px" : "0",
                    }}
                  >
                    {selectedImage2 ? (
                      <div
                        className="box_img_update"
                        style={{ marginTop: "-20px" }}
                      >
                                    
                        <img
                          src={URL.createObjectURL(selectedImage2)}
                          alt="Thumb"
                        />
                      </div>
                    ) : (
                      <div className="box_img_update">
                        <img src={img1} alt="image_id_1" />
                      </div>
                    )}
                        {" "}
                    {formValues.id_photo1.error && (
                      <div
                        style={{
                          color: "red",
                          marginTop: "10px",
                          height: "1px",
                        }}
                      >
                        {formValues.id_photo1.error}
                      </div>
                    )}
                         
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{
                      marginTop:
                        selectedImage2 !== "" &&
                        formValues.id_photo1.error == ""
                          ? "65px"
                          : selectedImage2 !== "" &&
                            formValues.id_photo1.error !== ""
                          ? "35px"
                          : "45px",
                    }}
                  >
                    <TextField
                      placeholder="الرجاءإدخال صورة الهوية  صورة الخلفية"
                      className="form-control"
                      label="صورة الهوية الخلفية"
                      name="id_photo1"
                      fullWidth
                      required
                      type="file"
                      onChange={imageChange2}
                    />
                  </Grid>
                </Grid>
                <Grid md={4} xs={4}>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                      marginBottom: selectedImage3 !== "" ? "20px" : "0",
                    }}
                  >
                    {selectedImage3 ? (
                      <div
                        className="box_img_update"
                        style={{ marginTop: "-20px" }}
                      >
                                    
                        <img
                          src={URL.createObjectURL(selectedImage3)}
                          alt="Thumb"
                        />
                      </div>
                    ) : (
                      <div className="box_img_update">
                        <img src={img2} alt="image_id_2" />
                      </div>
                    )}
                           {" "}
                    {formValues.id_photo2.error && (
                      <div style={{ color: "red", marginTop: "10px" }}>
                        {formValues.id_photo2.error}
                      </div>
                    )}
                         
                  </Grid>
                  <Grid
                    item
                    md={12}
                    xs={12}
                    style={{
                      marginTop:
                        selectedImage3 !== "" &&
                        formValues.id_photo2.error == ""
                          ? "65px"
                          : selectedImage3 !== "" &&
                            formValues.id_photo2.error !== ""
                          ? "-6px"
                          : "45px",
                    }}
                  >
                    <TextField
                      placeholder="الرجاءإدخال صورة الهوية  صورة الأمامية"
                      className="form-control"
                      label="صورة الهوية الأمامية"
                      name="id_photo2"
                      fullWidth
                      required
                      type="file"
                      onChange={imageChange3}
                    />
                  </Grid>
                </Grid>
              </Grid>

              {/* </Grid>  */}
              <Grid item md={6} xs={12}></Grid>
            </Grid>
            <Grid item md={6} xs={12} spacing={2} class="div-btn-submit">
              {loading === true ? (
                <>
                  <Controls.Button
                    text=<div class="spinner center">
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                      <div class="spinner-blade"></div>
                    </div>
                    variant="contained"
                    className="btn-submit"
                  ></Controls.Button>
                  <Controls.Button
                    type="submit"
                    text="إلغاء"
                    onClick={cancleUpdate}
                    variant="contained"
                    className="btn-submit1"
                    color="secondary"
                  ></Controls.Button>
                </>
              ) : (
                <>
                  <Controls.Button
                    type="submit"
                    text="تعديل"
                    variant="contained"
                    className="btn-submit"
                  ></Controls.Button>
                  <Controls.Button
                    type="submit"
                    text="إلغاء"
                    onClick={cancleUpdate}
                    variant="contained"
                    className="btn-submit1"
                    color="secondary"
                  ></Controls.Button>
                </>
              )}
            </Grid>
          </>
        ) : (
          <img src="loading.svg" alt="load" class="load" />
        )}
      </form>
    </div>
  );
}
